export const collectorMain = [
  {
    name: 'collector',
    path: '/collector',
    component: () => import('/@/views/plugins/collector/Collector.vue'),
    meta: {
      title: '数据采集',
      icon: 'icon-shebeiguanli',
      plugin: 'collector',
      keepAlive: true
    }
  },
  {
    path: '/collector/list',
    name: 'collectorList',
    component: () => import('/@/views/plugins/collector/Collector.vue'),
    meta: {
      title: '采集任务',
      plugin: 'collector',
      keepAlive: true
    }
  },
  {
    path: '/collector/record',
    name: 'collectorRecord',
    component: () => import('/@/views/plugins/collector/Record.vue'),
    meta: {
      title: '采集记录',
      plugin: 'collector',
      keepAlive: true
    }
  }
]

export default collectorMain
